import { NormalizeURLPath } from './functions';
import { PATH_MATCHER_PRIVATE } from './privates';
import { ConstructPathMatcher } from './constructor';
export function PathMatcherGetPath(instance) {
    return instance[PATH_MATCHER_PRIVATE].path;
}
export function PathMatcherExec(instance, path) {
    var privates = instance[PATH_MATCHER_PRIVATE];
    path = NormalizeURLPath(path);
    var match = privates.regExp.exec(path);
    if (match === null) {
        return null;
    }
    else {
        var params = new Map();
        for (var i = 0, l = match.length - 1; i < l; i++) {
            params.set(privates.params[i], match[i + 1]);
        }
        return Object.freeze({
            params: params,
            remaining: path.substring(match[0].length),
        });
    }
}
var PathMatcher = (function () {
    function PathMatcher(path) {
        ConstructPathMatcher(this, path);
    }
    Object.defineProperty(PathMatcher.prototype, "path", {
        get: function () {
            return PathMatcherGetPath(this);
        },
        enumerable: true,
        configurable: true
    });
    PathMatcher.prototype.exec = function (path) {
        return PathMatcherExec(this, path);
    };
    return PathMatcher;
}());
export { PathMatcher };
//# sourceMappingURL=implementation.js.map